// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.badge-container .v-badge__wrapper{\n\tposition: relative;\n}\n.conversation-button {\n\tposition: absolute;\n\ttop: -5px;\n\tright: -0px;\n\tbackground-color: white;\n\tborder-radius: 50%;\n\tz-index: 1;\n}\n.avatar-btn {\n\tcursor: pointer;\n}\n.emoji-wrapper{\n\tbackground-color: transparent !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
